<template>
  <div class="onboarding-landing">
    <div class="hero-section">
      <div class="container">
        <div class="hero-content">
          <div class="hero-text">
            <div class="hero-logo">
              <icon-base icon="logo" alt="ConveYour Logo" />
            </div>
            <h1 class="hero-title">Welcome to ConveYour!</h1>
            <h2 class="gradient-text">
              Build & Scale Field Teams Without Chaos
            </h2>
            <p class="hero-subtitle">
              Let's get you set up in just a few steps. Our AI will help you
              create engaging training experiences for your team.
            </p>
          </div>
        </div>
      </div>
    </div>

    <steps-list />
  </div>
</template>

<script>
import StepsList from '@/views/launch/components/StepsList.vue';

export default {
  name: 'LaunchView',
  components: {
    StepsList,
  },
  methods: {
    toggleIntercomLauncher(hide = false) {
      if (typeof window.Intercom === 'function') {
        window.Intercom('update', { hide_default_launcher: hide });
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.toggleIntercomLauncher(false);
    }, 1000);
  },
  beforeDestroy() {
    this.toggleIntercomLauncher(true);
  },
};
</script>

<style lang="less" scoped>
.onboarding-landing {
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(124, 77, 255, 0.03) 0%,
    rgba(0, 229, 255, 0.02) 50%,
    rgba(100, 255, 218, 0.03) 100%
  );
  overflow: auto;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

// Hero Section
.hero-section {
  padding: 40px 0 30px;

  .hero-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .hero-text {
    text-align: center;
    max-width: 800px;
  }

  .hero-logo {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
      margin-bottom: 20px;
    }

    @media (max-width: 480px) {
      margin-bottom: 16px;
    }

    :deep(.icon-base) {
      width: 48px;
      height: 48px;
      opacity: 0.9;
      transition: all 0.3s ease;

      &:hover {
        opacity: 1;
        transform: scale(1.05);
      }

      @media (max-width: 768px) {
        width: 40px;
        height: 40px;
      }

      @media (max-width: 480px) {
        width: 36px;
        height: 36px;
      }
    }
  }

  .hero-title {
    font-size: 3.5rem;
    font-weight: 900;
    margin-bottom: 16px;
    color: var(--v-main-base);
    letter-spacing: -0.02em;
    line-height: 1.1;

    @media (max-width: 768px) {
      font-size: 2.5rem;
    }

    @media (max-width: 480px) {
      font-size: 2rem;
    }
  }

  .gradient-text {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 24px;
    background: linear-gradient(
      135deg,
      #7c4dff 0%,
      #00e5ff 30%,
      #4db8a3 70%,
      #7c4dff 100%
    );
    background-size: 200% 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    letter-spacing: -0.01em;
    line-height: 1.2;
    animation: gradientShift 8s ease-in-out infinite;

    @media (max-width: 768px) {
      font-size: 1.8rem;
    }

    @media (max-width: 480px) {
      font-size: 1.5rem;
    }
  }

  .hero-subtitle {
    font-size: 1.25rem;
    line-height: 1.6;
    color: rgba(0, 0, 0, 0.75);
    max-width: 520px;
    font-weight: 500;
    margin: 0 auto;

    @media (max-width: 768px) {
      font-size: 1.125rem;
    }

    @media (max-width: 480px) {
      font-size: 1rem;
    }
  }

  @keyframes gradientShift {
    0%,
    100% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
  }
}
</style>

<style>
.intercom-lightweight-app {
  z-index: 100 !important;
}
</style>
